import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import store from '@/store'
// import { getToken } from '@/utils/auth'
import { errorCodeMap, downloadFile } from "@/utils/index";
import { logout } from "@/utils/logout";

// create an axios instance
console.log("process.env.VUE_APP_BASE_API", process.env);
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL:'http://office.xianci.info:18085/',
  // baseURL:'https://www.chrivc.com/api/',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    // if (store.getters.token) {
    if (sessionStorage.getItem("token")) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = sessionStorage.getItem("token");
      // config.headers['X-Token'] = getToken()
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response;
    // if the custom code is not 20000, it is judged as an error.
    const disposition = res.headers["content-disposition"] || "";
    if (disposition.indexOf("attachment") !== -1) {
      const dispositions = disposition.split("filename=");
      const fileName = dispositions[dispositions.length - 1];
      downloadFile(res.data, fileName);
      return res;
    }
    if (
      res.data.c !== 501005 &&
      res.data.c !== 501004 &&
      res.data.c !== 200 &&
      res.data.c !== 501010
    ) {
      if (res.data.c === 500) {
        Message({
          message: errorCodeMap(res.data.c),
          type: "error",
          duration: 5 * 1000
        });
      } else if (res.data.c === 501019) {
        return Promise.reject(res.data);
      } else {
        Message({
          message: res.data.m || "Error",
          type: "error",
          duration: 5 * 1000
        });
      }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.data.c === 403003 || res.data.c === 9000 || res.data.c === 405) {
        // to re-login
        MessageBox.alert("请重新登录", "登出确认", {
          confirmButtonText: "重新登录",
          callback: action => {
            logout();
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
        // MessageBox.confirm('请重新登录', '登出确认', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   logout()
        // })
      }
      return Promise.reject(new Error(res.data.m || "Error"));
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: "网络错误，请稍后重试",
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js